const Form088TC = {
    stepName: {
        importantNotes: "重要事項",
        information: "資料",
        confirmation: "確認",
    },
    title: {
        applicantParticulars: "申請人資料",
        schoolInformation: "學校資料",
        note: "注意",
        collectionStatement: "收集個人資料聲明",
    },
    label: {
        termsConditions: "本人已閱讀、理解及同意上述條款及條件。",
        nameEn: "英文姓名",
        nameCn: "中文姓名",
        email: "電郵地址（用作接收使用「成員專區」的確認電郵）",
        schoolTelNo: "學校電話號碼",
        schoolName: "學校名稱",
        schoolChop: "學校蓋印",
        principalName: "校長姓名/校監姓名",
        principalSignature: "校長姓名/校監姓名",
        date: "日期",
        noNameCn: "我沒有中文姓名。",
        supervisorOrPrincipal: {
            supervisor: "校監",
            principal: "校長",
        },
    },
    note: {
        note1: `有意登入`,
        note2: `「資優教育學校網絡」資源分享—成員專區`,
        note3: ` （下稱「成員專區」）的教師，請填妥以下電子表格並遞交予學校審批人批核。`,
        note4: ` 教育局承諾會確保一切個人資料均依照`,
        note5: ` 《個人資料（私隱）條例》`,
        note6: ` 的有關條文處理。詳情請參閱教育局的`,
        note7: ` {{statement}}。`,
        note8: ` 如有查詢，請致電聯絡鄺兆華先生（電話：3698 3480）。`,
    },
    errorMsg: {
        alphabetsOnly: "字符類型只允許 (英文)",
        chineseOnly: "字符類型只允許 (中文)",
    },
};
export default Form088TC;
